import { CommonClientError } from "../../error";
import { DateUtils } from "../../primitive-utils";
import { REGEX_LOCAL_TIME } from "../../primitive/time/base/time-regex";
import { LocalDateTimeFunc } from "../date-time";
import { HH_MM, LOCAL_TIME_FORMAT } from "../time-format";
export class LocalTimeFunc {
    v;
    constructor(v) {
        this.v = v;
    }
    static EndOfDay = LocalTimeFunc.of({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 999,
    });
    static of({ hour = 0, minute = 0, second = 0, millisecond = 0, }) {
        const date = new Date(2022, 0, 1, hour, minute, second, millisecond);
        if (date.getHours() !== hour ||
            date.getMinutes() !== minute ||
            date.getSeconds() !== second ||
            date.getMilliseconds() !== millisecond) {
            const formattedTime = `${hour}:${minute}:${second}.${millisecond}`;
            throw new CommonClientError.InvalidInput(`LocalTime invalid error. input[${formattedTime}]`, `存在しない時刻です。`);
        }
        return new LocalTimeFunc({
            hour,
            minute,
            second,
            millisecond,
        });
    }
    static parse(text, format = HH_MM) {
        return this.fromDate(DateUtils.fromFormat(text, format));
    }
    // 正規表現からPraseする。
    // ただし、数字部分が HH mm ss SSS の順番であることを前提とする。
    static parseFromRegex(text, regex = REGEX_LOCAL_TIME) {
        if (!regex.test(text)) {
            throw new CommonClientError.InvalidInput(`LocalDate regex match error. regex[${regex.source}], input[${text}]`, "時刻の形式が不正です。");
        }
        const extractRegex = /\d+/g; // 数字を抽出
        const [hour, minute, second, millisecond] = text.match(extractRegex) ?? [];
        return LocalTimeFunc.of({
            hour: Number(hour ?? 0),
            minute: Number(minute ?? 0),
            second: Number(second ?? 0),
            millisecond: Number(millisecond?.padEnd(3, "0").slice(0, 3) ?? 0),
        });
    }
    /** DateをJST解釈のLocalTimeに変換して返す */
    static fromDateJST(v) {
        const jstDate = DateUtils.utcToJSTTime(v);
        return this.fromDate(jstDate);
    }
    atDate(date) {
        return LocalDateTimeFunc.of({ ...date.toValues(), ...this.toValues() });
    }
    equals(other) {
        return this.toDate().getTime() === other.toDate().getTime();
    }
    isAfter(other) {
        return this.toDate().getTime() > other.toDate().getTime();
    }
    isBefore(other) {
        return this.toDate().getTime() < other.toDate().getTime();
    }
    toValues() {
        return this.v;
    }
    format(format = HH_MM) {
        return DateUtils.format(this.toDate(), format, true);
    }
    toString() {
        const d = this.toDate();
        return DateUtils.format(d, LOCAL_TIME_FORMAT);
    }
    // Dateで受け付ける関数を呼びたいときのアダプタ
    //   private callAsDate(func: (d: Date) => Date) {
    //     const d = this.toDate();
    //     const result = func(d);
    //     return LocalTimeFunc.fromDate(result);
    //   }
    toDate() {
        return new Date(2022, 0, 1, this.v.hour, this.v.minute, this.v.second, this.v.millisecond);
    }
    static fromDate(d) {
        return LocalTimeFunc.of({
            hour: d.getHours(),
            minute: d.getMinutes(),
            second: d.getSeconds(),
            millisecond: d.getMilliseconds(),
        });
    }
}
//# sourceMappingURL=local-time.js.map